import React from "react";
import { Box, Typography } from "@mui/material";

export default function DevolucionTrabajoCampo() {
  return (
    <Box className="p-4 border border-dashed rounded-lg min-h-[300px]">
      <Typography variant="h6">Trabajo de campo (Devolución)</Typography>
      {/* Checklist de retiro, evidencias (fotos), recepción de equipos, etc. */}
    </Box>
  );
}